import styled from "styled-components/macro";

export const Wrapper = styled.div`
  font-size: 0.75rem;
  padding: 1.5rem;

  *.highlighted {
    font-weight: normal;
    margin-top: 0;
    background-color: yellow;
  }
  *.highlighted2 {
    font-weight: normal;
    margin-top: 0;
    background-color: #87CEFA;
  }
  *.highlighted3 {
    font-weight: normal;
    margin-top: 0;
    background-color: #FBB239;
  }
  *.highlighted4 {
    font-weight: normal;
    margin-top: 0;
    background-color: #FFB776;
  }
`;

export const ModulesRow = styled.div`
  display: flex;
  gap: 2rem;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
    div {
    display: flex;
    column-gap: 1rem;
  }
`;
